// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_SalvaBairroInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /localidades/salvaBairro
 *
 * Creates or updates a neighborhood in the locations service.
 */
import { registerContract } from './validate'

export interface Localidades_SalvaBairroInput {
bairro_nome: string
cidade_id: number
bairro_id?: number
}

registerContract('Localidades_SalvaBairroInput', {
  bairro_nome: { type: 'string',  required: true },
  cidade_id:   { type: 'number',  required: true },
  bairro_id:   { type: 'number',  required: false },
})
